export default __webpack_public_path__ + "static/logo_white-f2e74f1e2d3757d5ccb6593bdc623ea0.svg";